import { SnackBarService } from "src/app/services/common/snackBar.service";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelectChange
} from "@angular/material";

import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import { ICoursePattern } from "src/app/interfaces/coursePattern";
import { CoursePatternEntryComponent } from "../course-pattern-entry/course-pattern-entry.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IActivePattern } from "src/app/interfaces/activePattern";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CIDService } from "src/app/services/common/cid.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: "app-course-pattern-list",
  templateUrl: "./course-pattern-list.component.html",
  styleUrls: ["./course-pattern-list.component.css"]
})
export class CoursePatternListComponent implements OnInit {
  displayedColumns: string[] = [
    this.translate.get("label.patternName"),
    'courseType',
    this.translate.get("label.sessionQty"),
    this.translate.get("label.sessionDuration"),
    this.translate.get("label.containDiscount"),
    this.translate.get("label.status"),
    "function"
  ];
  isOwner: boolean;
  list: ICoursePattern;
  compnayList: ICompany;
  companySelected: string;
  courseDetail: ICoursePattern;
  dataSource = new MatTableDataSource<ICoursePattern>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorsService: ErrorsService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private coursPatternService: CoursePatternService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.dataSource.paginator = this.paginator;
    this.companySelected = this.cidService.getCID();
    this.refresh();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  loadPattern(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    var delayInMilliseconds = 500; //1 second
    var _this = this;
    setTimeout(function () {
      _this.refresh();
    }, delayInMilliseconds);
  }

  refresh() {
    this.coursPatternService.getList().subscribe(res => {
      this.companySelected = this.cidService.getCID();
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.coursPatternService
      .getList(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  add() {
    this.dialog
      .open(CoursePatternEntryComponent, {
        width: "500px",
        maxHeight: "500px",
        data: null
      })
      .afterClosed()
      .subscribe(() => {
        this.coursPatternService.getList().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  edit(id: number) {
    this.coursPatternService.getById(id).subscribe(res => {
      this.courseDetail = res;
      this.dialog
        .open(CoursePatternEntryComponent, {
          width: "500px",
          maxHeight: "500px",
          data: this.courseDetail
        })
        .afterClosed()
        .subscribe(() => {
          this.refresh();
        });
    });
  }

  delete(data: ICoursePattern): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.pattern") + " " + data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.coursPatternService.delete({Id: data.Id}).subscribe(
          () => {
            this.refresh();
          },
          err => {
            this.errorsService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  ative(data: ICoursePattern): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.pattern") + " " + data.Title
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.pattern") + " " + data.Title
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var activate: IActivePattern = {
        xActive: !data.IsActive,
        Id: data.Id
      };
      if (result) {
        this.coursPatternService.patternActive(activate).subscribe(
          () => {
            this.refresh();
          },
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("error.active", {
                name: this.translate.get("label.pattern")
              }),
              "OK",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
